import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { configureStore } from '@store';
import { FontStyle, ResetStyle, theme } from '@styles';
import { Router } from '@router';
import { clearStorageOnScriptError } from '@helpers/common';

export const { store, persistor } = configureStore();

clearStorageOnScriptError();

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <ResetStyle />
          <FontStyle />
          <Router />
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </PersistGate>
  </Provider>
);

export default App;
